import React from "react";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import { 
  Person as PersonIcon,
  WorkOutline as WorkIcon,
  LocationOn as LocationIcon,
  CalendarToday as CalendarIcon,
  LinkedIn as LinkedInIcon,
  Work as WorkAuthIcon
} from "@mui/icons-material";
import sharedStyles from "./sharedStyles";

interface PersonalInfoData {
  status: string;
  experience: string;
  relocation: string;
  address: string;
  workAuth: string;
  name: string;
  email: string;
  phone: string;
  location: string;
  yearOfExperience: string;
  availability: string;
}

interface CandidatePersonalInfoProps {
  data: PersonalInfoData;
}

const CandidatePersonalInfo: React.FC<CandidatePersonalInfoProps> = ({ data }) => {
  const infoFields = [
    {
      label: "Work Authorization",
      value: data.workAuth,
      icon: <WorkAuthIcon sx={sharedStyles.smallIcon} />,
    },
    {
      label: "Availability",
      value: data.availability,
      icon: <CalendarIcon sx={sharedStyles.smallIcon} />,
    },
  ].filter(field => field.value && field.value !== "N/A");

  return (
    <Card sx={{ ...sharedStyles.card }}>
      <CardContent>
        <Box sx={sharedStyles.title}>
          <PersonIcon sx={sharedStyles.smallIcon} />
          <Typography variant="h6" fontWeight="bold" data-testid="personal-info-title">
            Personal Details
          </Typography>
        </Box>

        <Box
          sx={{
            ...sharedStyles.scrollableContainer,
            maxHeight: "210px",
          }}
          data-testid="personal-info-box"
        >
          <Grid container spacing={2}>
            {infoFields.map((field) => (
              <Grid item xs={12} key={field.label} data-testid={`personal-info-field-${field.label}`}>
              <Box
                sx={{
                  p: 2,
                  backgroundColor: "white",
                  borderRadius: 2,
                  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                }}
              >
                <Box sx={{ 
                  display: "flex", 
                  alignItems: "center",
                  justifyContent: "space-between",
                }}>
                  <Box sx={{ 
                    display: "flex", 
                    alignItems: "center",
                    minWidth: "140px", // Ensure consistent spacing for labels
                  }}>
                    {React.cloneElement(field.icon, {
                      sx: { ...field.icon.props.sx, mr: 1, color: "#3b82f6" },
                    })}
                    <Typography
                      sx={{
                        fontWeight: "500",
                        color: "#1e293b",
                      }}
                      data-testid={`personal-info-label-${field.label}`}
                    >
                      {field.label}:
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: "400",
                      color: "#4b5563",
                      fontSize:"14px",
                      textAlign: "right"
                    }}
                    data-testid={`personal-info-value-${field.label}`}
                  >
                    {field.value} {/* Display the actual value */}
                  </Typography>
                </Box>
              </Box>
            </Grid>
            
            ))}
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CandidatePersonalInfo;